import { gql } from 'graphql-request';
import { pathOr } from 'ramda';
import { getNamespaceName } from '../objects/namespaces';
import { useRequestGQLQuery } from 'src/services/grapqlQueries/useGraphQLQuery';

export const GQLGetDocumentAccessControls = async (
  roles: string[],
) => {
  const result = await useRequestGQLQuery(
    DESCRIBE_DOCUMENT_ACCESS_CONTROLS,
    {
      roles,
      objectMeta: { namespace: getNamespaceName() },
    }
  );

  return pathOr([], ['document_access_controls'], result);
};


export const GET_DOCUMENT_ACCESS_CONTROLS = `document_access_controls(
  where: {
    object_meta: { _contains: $objectMeta }
    persona: { _in: $roles }
  }
) {
  access_controls
  created_at
  id
  loantype
  metadata
  object_meta
  permitted_access
  persona
  type_meta
  folder
  options
}`


const DESCRIBE_DOCUMENT_ACCESS_CONTROLS = gql`query describeAccessControl($roles: [String]! $objectMeta: jsonb) {
    ${GET_DOCUMENT_ACCESS_CONTROLS}
  }
`;